import { ROUTES } from "@/app/constants";
import type { UserRole } from "@/features/auth/types";

/**
 * Where a signed-in user should land based on their role.
 *
 * ADMIN / SUPER_ADMIN / STAFF (internal roles) land on Home (`/home`) —
 * one employee, one dashboard (owner, 2026-09-10). Between 2026-07-16 and
 * then they landed on Services, because the old Dashboard tab was a dead
 * placeholder; Home is composed per person and per role, so there is a
 * page worth landing on again. CLIENT lands in the client portal
 * (`/portal`). Anything unrecognized falls back to the client portal —
 * safer than dropping an unknown role into the admin shell by default.
 *
 * Kept as a standalone module (not colocated in RoleGuard) so `GuestGuard`
 * and the root-path redirect can share the same decision without a
 * circular import.
 */
export function pickHomeForRole(role?: UserRole): string {
  switch (role) {
    case "ADMIN":
    case "SUPER_ADMIN":
    case "STAFF":
    case "admin":
    case "staff":
    case "manager":
      return ROUTES.home;
    case "CLIENT":
    case "lead":
      return ROUTES.portal;
    default:
      return ROUTES.portal;
  }
}
